import React from 'react';
import { ChevronDown } from 'lucide-react';

export default function CollapsibleSection({ title, icon: Icon, defaultOpen = true, children, badge }) {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="border border-neutral-200 rounded-xl bg-white overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between px-4 py-3.5 hover:bg-neutral-50 transition-colors"
      >
        <span className="flex items-center gap-2.5">
          {Icon && <Icon className="w-4 h-4 text-orange-600" strokeWidth={2} />}
          <span className="text-sm font-semibold text-neutral-800">{title}</span>
          {badge && (
            <span className="text-[10px] font-medium px-1.5 py-0.5 rounded-full bg-orange-50 text-orange-700 border border-orange-200">
              {badge}
            </span>
          )}
        </span>
        <ChevronDown
          className={`w-4 h-4 text-neutral-400 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
        />
      </button>
      <div
        className={`transition-[max-height,opacity] duration-200 ease-in-out overflow-hidden ${open ? 'max-h-[3000px] opacity-100' : 'max-h-0 opacity-0'}`}
      >
        <div className="px-4 pb-5 pt-1 space-y-4">{children}</div>
      </div>
    </div>
  );
}
